import { themeStyle } from '@repo/ui/theming';

export const defaultTheme = {
  color: themeStyle.varInkMedium,
  trackColor: themeStyle.varInkLight,
  borderWidth: '2px',
};
